import { USER_TYPE_STANDARD, useUserSession } from '@solinkcorp/authentication';

function useIsUserStandard() {
  const user = useUserSession();
  return user?.profile.userType === USER_TYPE_STANDARD;
}

export default useIsUserStandard;
